import { ResponsiveGrid } from '@alifd/next';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import ReservationList from './components/ReservationList';

const { Cell } = ResponsiveGrid;

const CleanAppointmentRecord = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="一般清潔預約清單"
        breadcrumbs={[
          {
            name: '清潔打掃',
          },
          {
            name: '一般清潔預約清單',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <ReservationList />
    </Cell>
  </ResponsiveGrid>
);

export default CleanAppointmentRecord;
